import { FC, ReactElement, useMemo } from 'react';

import { RaaExpandablePreview } from 'raa-react';

import { DrawerSection } from 'components/drawerSections/DrawerSections';

import { BebyggelseobjektDomaner, Egenskap } from 'models';

import { renderWithParagraphs } from 'utilities/renderWithParagraphs';

interface BebyggelseBeskrivningSectionProps {
  domaner?: BebyggelseobjektDomaner;
  beskrivning?: string;
  egenskaper?: Egenskap[];
}

const BebyggelseBeskrivningSection: FC<BebyggelseBeskrivningSectionProps> = (props): ReactElement => {
  const egenskaperTable = useMemo(() => {
    const egenskaperRows = [];

    for (const egenskap of props.domaner?.egenskaper || []) {
      const egenskaperList = props.egenskaper?.filter((u) => u.egenskapstyp_id === egenskap.egenskapstyp);
      if (egenskaperList && egenskaperList.length > 0) {
        egenskaperRows.push(
          <tr key={egenskap.egenskapstyp}>
            <th className="tw-align-top">{egenskap.namn}</th>
            <td>{egenskaperList.map((data) => data.egenskapsvarde_namn).join(', ')}</td>
          </tr>
        );
      }
    }

    return egenskaperRows.length === 0 ? (
      <></>
    ) : (
      <table className="tw-mt-2">
        <tbody className="[&>tr>td]:tw-pl-6 [&>tr>td]:tw-capitalize [&>tr>th]:tw-text-left">{egenskaperRows}</tbody>
      </table>
    );
  }, [props.domaner?.egenskaper, props.egenskaper]);

  return (
    <DrawerSection>
      <h2 className="tw-heading-md tw-mb-4">Beskrivning</h2>
      <RaaExpandablePreview ariaLabel="beskrivning">
        {renderWithParagraphs(props.beskrivning || 'Ingen beskrivning registrerad')}
        {egenskaperTable}
      </RaaExpandablePreview>
    </DrawerSection>
  );
};

export default BebyggelseBeskrivningSection;
